var map = {
	"./balloon.jpg": 305,
	"./capetown_1.jpg": 306,
	"./capetown_2.jpg": 307,
	"./capetown_3.jpg": 100,
	"./capetown_4.jpg": 308,
	"./capetown_5.jpg": 309,
	"./garden.jpg": 101,
	"./hiker.jpg": 310,
	"./lighthouse_1.jpg": 311,
	"./lighthouse_2.jpg": 312,
	"./mountain_1.jpg": 102,
	"./mountain_2.jpg": 313,
	"./mountain_3.jpg": 314,
	"./sculpture.jpg": 315,
	"./shark_1.jpg": 316,
	"./shark_2.jpg": 317,
	"./wine_1.jpg": 318,
	"./wine_2.jpg": 319
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 348;



//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock/capetown nonrecursive \.(png|jpe?g|svg)$
// module id = 348
// module chunks = 0